<template>
<div class="page_iteminfo">
</div>
</template>

<script>
import router from '../../../.././router'
import {
    LOGOUT,
    LOGIN
} from '../../../.././vuex/mutation_types'
import PageSearch from '../../../component/search/Index.vue' // 搜索组件
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            uuid: this.$route.params.uuid
        }
    },

    created: function () {
        this.getData()
        console.log('uuid', this.uuid)
    },
    methods: {
        // 获取数据
        getData() {
            var params = {
                good_num: this.uuid
            }
            this.$api.shop.oldgoods(params).then(res => {
                if (res.code == 200) {
                    if (res.result.isset == 1) {
                        var goodsId = res.result.id
                        this.$router.push({
                            path: '/shop/detail',
                            query: {
                                goodsId: goodsId
							}
                        })
                    } else {
                        this.$router.push({
                            path: '/'
                        })
                    }
                }
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

</style>
